import i18n from 'i18next';
import { WILEYCOM_HOST_URL } from '@config/constants';
import { ReactComponent as WLogo } from '@assets/images/w-logo.svg';

export const breadcrumbs = (locale: string): { url: string, children: React.ReactNode }[] => ([
  {
    url: `${WILEYCOM_HOST_URL}/${locale}`,
    children: <WLogo />,
  },
  {
    url: '/cart',
    children: i18n.t('cart.emptyCart.yourCart'),
  },
]);
